export default __webpack_public_path__ + "3f8d8e609e483b4ad62b2b9c2f149697.png";